import DynamicLandingPage from './DynamicLanding';

export default DynamicLandingPage;
